/**
 * Created by Administrador on 13/01/2017.
 */
(function(){
    'use strict';

    angular
        .module('completeAir')
        .factory('taxService', taxService);

    taxService.$inject = ['$http', 'CONFIG', 'messageService'];

    function taxService($http, CONFIG, messageService){
        var urlBase = CONFIG.API_URL + '/' + CONFIG.API_FARE_CONTROL + '/' + CONFIG.API + '/taxes';
        var service = {
            getTaxes: getTaxes,
            getTax: getTax,
            saveTax: saveTax,
            updateTax: updateTax,
            deleteTax: deleteTax,
            getTaxesList: getTaxesList,
            getTypeTaxByType: getTypeTaxByType
        }

        return service;

        function getTaxes(page, size, detailed){
            return $http.get(urlBase + '?detailed='+detailed+'&page=' + page + '&size=' + size)
                .then(function(response){
                    return response;
                })
                .catch(function(){
                    messageService.findAllError('');
                });
        }

        function getTax(taxId){
            return $http.get(urlBase + '/' + taxId)
                .then(function(response){
                    return response;
                })
                .catch(function(){
                    messageService.findAllError('');
                });
        }

        function saveTax(tax){
            return $http.post(urlBase, tax)
                .then(function(response){
                    messageService.register('taxes');
                    return response;
                })
                .catch(function(){
                    messageService.registerError('taxes');
                });
        }

        function updateTax(taxId, tax){
            return $http.put(urlBase + "/" + taxId, tax)
                .then(function(response){
                    messageService.registerUpdate('taxes');
                    return response;
                })
                .catch(function(){
                    messageService.registerUpdate('taxes');
                });
        }

        function deleteTax(taxId){
            return $http.delete(urlBase + "/" + taxId)
                .then(function(response){
                    messageService.registerDelete('taxes');
                    return response;
                })
                .catch(function(){
                    messageService.registerDeleteError('taxes');
                });
        }

        function getTaxesList(){
            return $http.get(urlBase + '/source')
                .then(function(response){
                    return response;
                })
                .catch(function(){
                    messageService.findAllError('');
                });
        }

        function getTypeTaxByType(typeTaxes, type) {
            var res = null;
            for (var i = 0; i < typeTaxes.length; i++) {
                if (typeTaxes[i].type === type) {
                    res = typeTaxes[i];
                    break;
                }
            }
            return res;
        }
    }
})();
